import type { ChatUIAffectingMessage } from '../../types/centrifuge/chatTypes';

/**
 * 채팅 메시지 배열의 길이를 제한하는 함수
 * 단일 메시지 또는 배치 메시지 모두 처리 가능
 *
 * @param currMessages 현재 채팅 메시지 배열
 * @param newMessages 추가할 메시지 (단일 또는 배열)
 * @param limit 최대 메시지 개수 (기본값: 300)
 * @returns 길이가 제한된 채팅 메시지 배열
 */
const limitChatMessagesLength = (
  currMessages: ChatUIAffectingMessage[],
  newMessages: ChatUIAffectingMessage | ChatUIAffectingMessage[],
  limit: number = 300,
): ChatUIAffectingMessage[] => {
  const messagesArray = Array.isArray(newMessages) ? newMessages : [newMessages];

  const combinedMessages = [...currMessages, ...messagesArray];

  if (combinedMessages.length > limit) {
    return combinedMessages.slice(combinedMessages.length - limit);
  }

  return combinedMessages;
};

export default limitChatMessagesLength;
